import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'guest-role',
    templateUrl: './guest.component.html'
})
export class GuestRoleComponent {
}

